import React from 'react'
import {useSelector} from 'react-redux'
import {IReduxState} from '../../../redux/types/IReduxState'
import {SolutionSql} from '../components/SolutionSql'

interface IMasterSolutionProps {
  id: string
}

const MasterSolution: React.FC<IMasterSolutionProps> = (): React.ReactElement => {
  const solution = useSelector<IReduxState, string | undefined>((state) => state.task?.solution)

  return <SolutionSql sql={solution} />
}

export {MasterSolution}
